// Capabilities that are available in native app
enum NativeCapability {
  DismissBanner = 'DismissBanner'
}

export default NativeCapability;
